import { render } from "./AboutOrg.vue?vue&type=template&id=5d1ba725&scoped=true"
import script from "./_AboutOrg.js?vue&type=script&lang=js&external"
export * from "./_AboutOrg.js?vue&type=script&lang=js&external"

import "./_AboutOrg.less?vue&type=style&index=0&id=5d1ba725&lang=less&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1ba725"]])

export default __exports__